<template>
    <b-card>
        <form @submit.prevent="validate">
            <div class="form-row justify-content-start">
                <!-- <div class="col-md-2">
                    <div class="form-group selectpicker" data-live-search="true">
                        <label>Origem</label>
                        <select :class="{'custom-select': true}" v-model="value.origin">
                            <option value="">Todos</option>
                            <option value="Device">Presencial</option>
                            <option value="Web">Web</option>
                            <option value="Cash">Dinheiro</option>
                        </select>
                    </div>
                </div>   -->
                <div class="col-md-3" v-if="!$auth.isSeller">
                    <div class="form-group">
                        <label>Empresas</label>
                        <model-list-select
                            :list="sellers.data"
                            option-value="id"
                            option-text="name"
                            v-model="value.seller"
                            placeholder="Digite o nome da empresa"
                            @searchchange="searchSellers"
                        ></model-list-select>
                    </div>
                </div>          
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Terminais POS</label>
                        <model-list-select
                            :list="devices.data"
                            option-value="serialNumber"
                            :custom-text="item => `${item.modelName} - ${item.serialNumber}`"
                            v-model="value.device"
                            placeholder="Digite o nome do terminal"
                            @searchchange="searchDevices"
                        ></model-list-select>              
                    </div>
                </div>
                <div class="col-md-3" v-if="!$auth.isSeller">
                    <div class="form-group">
                        <label>Representantes</label>
                        <model-list-select
                            :list="salesPeople.data"
                            option-value="id"
                            option-text="name"
                            v-model="value.salesPerson"
                            placeholder="Digite o nome do representante"
                            @searchchange="searchSalesPeople"
                        ></model-list-select>              
                    </div>
                </div>
            </div>
            <div class="row justify-content-start">
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Forma de Pagamento</label>
                        <v-wait for="loading-paymentmethodtype">
                            <template slot="waiting">
                            <input disabled type="text" value="Aguarde..." class="form-control" />
                            </template>
                            <select v-model="value.paymentMethodType" class="custom-select">
                            <!--multiple="multiple"-->
                            <option
                                v-for="(s, index) in paymentMethodTypes"
                                :key="index"
                                :value="s.id"
                                >{{s.name}}</option>
                            </select>
                        </v-wait>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group selectpicker" data-live-search="true">
                        <label>Bandeira</label>
                        <v-wait for="loading-paymentmethod">
                            <template slot="waiting">
                            <input disabled type="text" value="Aguarde..." class="form-control" />
                            </template>
                            <select :class="{'custom-select': true}" v-model="value.paymentMethod">
                            <option
                                v-for="(s, index) in paymentMethods"
                                :key="index"
                                :value="s.id"
                            >{{s.name}}</option>
                            </select>
                        </v-wait>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group selectpicker" data-live-search="true">
                    <label>Tipo</label>
                    <select :class="{'custom-select': true}" v-model="value.hasInstallments">
                        <option value="">Todos</option>
                        <option value="false">À vista</option>
                        <option value="true">Parcelado</option>
                    </select>
                    </div>
                </div>       
            </div>
            <div class="row justify-content-start">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Início</label>
                        <datepicker
                            :language="languages.ptBR"
                            :bootstrapStyling="true"
                            placeholder="Início"
                            :calendar-button="true"
                            calendar-button-icon="fa fa-calendar"
                            v-model="value.startDate"
                        ></datepicker>
                    </div>
                </div>
                <!-- <div class="col-sm-2">
                    <div class="form-group">  
                        <label>Horario</label>
                        <div>
                            <vue-timepicker input-class="form-control" v-model="value.startHour" format="HH:mm:ss"></vue-timepicker>
                        </div>          
                    </div>
                </div>                 -->
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Término</label>
                        <datepicker
                            :language="languages.ptBR"
                            :bootstrapStyling="true"
                            placeholder="Termino"
                            :calendar-button="true"
                            calendar-button-icon="fa fa-calendar"
                            v-model="value.endDate"
                        ></datepicker>
                    </div>
                </div>
                <!-- <div class="col-sm-2">
                    <div class="form-group">  
                        <label>Horario</label>
                        <div>
                            <vue-timepicker input-class="form-control" v-model="value.endHour" format="HH:mm:ss"></vue-timepicker>
                        </div>
                    </div>
                </div>                     -->
            </div>
            <input type="submit" class="btn btn-primary" value="Buscar" />
        </form>
    </b-card>
</template>
<style>
  .vue__time-picker input.display-time {
    height: 35px !important;
  }
</style>
<script>
import { ModelListSelect } from "vue-search-select";
import sellerService from "../../services/Customer/sellerService";
import salesPersonService from "../../services/Customer/salesPersonService";
import deviceService from "../../services/Devices/deviceService";
import cardService from "../../services/PaymentMethods/paymentMethodService";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css';
import { getDateDayBefore } from "../../shared/utils";
import * as lang from "vuejs-datepicker/src/locale";
import eventbus from '../../eventBus';
export default {
    name: 'transactions-filter',
    inject: ['$validator'],
    components: {
        ModelListSelect,
        Datepicker,
        VueTimepicker
    },
    props: {
        value: {
            type: Object,
            default: {
                startDate: getDateDayBefore(new Date(), 7),
                startHour: '00:00:00',
                endDate: new Date(),
                endHour: '23:59:59',
                hasInstallments: '',
                origin: '',
                seller: '',
                device: '',
                salesPerson: '',
                paymentMethod: null,
                paymentMethodType: null
            }
        }
    },
    watch: {
        'value': function() {
            this.$emit('input', this.value)
        }
    },
    data() {
        return {
            sellers: {
                data: [],
                query: '',
            },
            devices: {
                data: [],
                query: '',
            },
            salesPeople: {
                data: [],
                query: '',
            },
            paymentMethods: [],
            paymentMethodTypes: [],
            languages: lang
        }
    },
    async created(){
        await this.fetchPaymentMethodData();
        this.fetchPaymentMethodTypeData();
    },
     filters: {
        stringify(value) {
            return JSON.stringify(value, null, 2);
        },
    },
    methods: {
        validate() {
            eventbus.$emit(`transactions-filter:search`);
        },        
        async fetchPaymentMethodData() {
            this.$wait.start("loading-paymentmethod");      
            let response = await cardService.all();
            this.paymentMethods =
                response.status == 204 ? [] : response.data;
            this.paymentMethods.unshift({ id: null, name: "Todos" });
            this.$wait.end("loading-paymentmethod");      
        },
        fetchPaymentMethodTypeData() {
            const self = this;
            this.$wait.start("loading-paymentmethodtype");
            cardService.allTypes().then(
                (response) => {
                    self.paymentMethodTypes =
                        response.status == 204 ? [] : response.data;
                    self.paymentMethodTypes.unshift({ id: null, name: "Todos" });
                    self.paymentMethodTypes.splice(3, 3);
                    self.$wait.end("loading-paymentmethodtype");
                },
                () => {
                    self.$wait.end("loading-paymentmethodtype");
                }
            );
        }, 
        searchSellers(newQuery) {
            if (newQuery == null || newQuery.length < 2) return;
            const self = this;
            
            sellerService.all(newQuery).then(
                (response) => {
                    self.sellers.data = response.status == 204 ? [] : response.data;
                },
                () => {
                    self.sellers.data = [];
                }
            );
        },
        searchDevices(q) {
            if (q == null || q.length < 2) return;
            const self = this;            
            deviceService.all(q).then(
                (response) => {
                    self.devices.data = response.status == 204 ? [] : response.data;                    
                },
                () => {
                    self.devices.data = [];
                }
            );
        },
        searchSalesPeople(q) {
            if (q == null || q.length < 2) return;
            const self = this;            
            salesPersonService.all(q, '').then(
                (response) => {
                    self.salesPeople.data = response.status == 204 ? [] : response.data;
                },
                () => {
                    self.salesPeople.data = [];
                }
            );
        } 
    }
}
</script>